module.exports = __webpack_public_path__ + "static/media/activity-responded.65b2569f.svg";